// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__oItJD","version":"Footer_version__bKaH5","logos":"Footer_logos__ps8bz","link":"Footer_link__QDxoG","logo":"Footer_logo__FqaJj"};